(() => {
  const POWER_SELECTOR = '[data-h2-power-interactive]';
  const SPECS_SELECTOR = '[data-h2-spec-interactive]';

  function initPower(root) {
    if (!root || root.dataset.h2PowerInit === 'true') return;
    root.dataset.h2PowerInit = 'true';
    const visual = root.querySelector('.h2p-power__visual');
    const buttons = [...root.querySelectorAll('[data-h2-power-hotspot]')];
    if (!buttons.length) return;
    let locked = null;

    const setOpen = (button, shouldOpen) => {
      if (!button) return;
      button.classList.toggle('is-open', shouldOpen);
      button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      const card = button.querySelector('.h2p-power__hotspot-card');
      if (card) card.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
      if (visual) visual.classList.toggle('is-hotspot-active', buttons.some((item) => item.classList.contains('is-open')));
    };
    const closeOthers = (keep) => buttons.forEach((button) => { if (button !== keep) setOpen(button, false); });

    buttons.forEach((button) => {
      button.addEventListener('pointerenter', () => {
        if (locked && locked !== button) return;
        closeOthers(button);
        setOpen(button, true);
      });
      button.addEventListener('pointerleave', () => {
        if (locked === button) return;
        setOpen(button, false);
      });
      button.addEventListener('focus', () => {
        closeOthers(button);
        setOpen(button, true);
      });
      button.addEventListener('blur', () => {
        if (locked !== button) setOpen(button, false);
      });
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        if (locked === button) {
          locked = null;
          setOpen(button, false);
        } else {
          locked = button;
          closeOthers(button);
          setOpen(button, true);
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!locked || root.contains(event.target)) return;
      setOpen(locked, false);
      locked = null;
    });
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (locked) setOpen(locked, false);
      locked = null;
    });
  }

  function initGeometry(root) {
    if (!root || root.dataset.h2SpecsInit === 'true') return;
    root.dataset.h2SpecsInit = 'true';
    const rows = [...root.querySelectorAll('[data-h2-geometry-row]')];
    const hotspots = [...root.querySelectorAll('[data-h2-geometry-hotspot]')];
    const tip = root.querySelector('[data-h2-geometry-tip]');
    const tipLabel = root.querySelector('[data-h2-geometry-tip-label]');
    const tipValue = root.querySelector('[data-h2-geometry-tip-value]');
    if (!rows.length || !hotspots.length) return;

    let lockedKey = null;
    const keyOf = (node) => node?.dataset?.h2GeometryRow || node?.dataset?.h2GeometryHotspot || '';

    const clear = () => {
      rows.forEach((row) => row.classList.remove('is-active'));
      hotspots.forEach((hotspot) => {
        hotspot.classList.remove('is-active');
        hotspot.setAttribute('aria-pressed', 'false');
      });
      if (tip) tip.hidden = true;
    };

    const activate = (key, source) => {
      if (!key) return;
      rows.forEach((row) => row.classList.toggle('is-active', keyOf(row) === key));
      hotspots.forEach((hotspot) => {
        const active = keyOf(hotspot) === key;
        hotspot.classList.toggle('is-active', active);
        hotspot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const dataNode = source || rows.find((row) => keyOf(row) === key) || hotspots.find((hotspot) => keyOf(hotspot) === key);
      if (tip && dataNode) {
        if (tipLabel) tipLabel.textContent = dataNode.dataset.h2GeometryLabel || key;
        if (tipValue) tipValue.textContent = dataNode.dataset.h2GeometryValue || '';
        tip.hidden = false;
      }
    };

    const bind = (node) => {
      const key = keyOf(node);
      node.addEventListener('pointerenter', () => { if (!lockedKey) activate(key, node); });
      node.addEventListener('pointerleave', () => { if (!lockedKey) clear(); });
      node.addEventListener('focus', () => { if (!lockedKey) activate(key, node); });
      node.addEventListener('blur', () => { if (!lockedKey) clear(); });
      node.addEventListener('click', (event) => {
        event.stopPropagation();
        if (lockedKey === key) {
          lockedKey = null;
          clear();
        } else {
          lockedKey = key;
          activate(key, node);
        }
      });
      if (node.matches('[data-h2-geometry-row]')) {
        node.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          node.click();
        });
      }
    };

    rows.forEach(bind);
    hotspots.forEach(bind);
    document.addEventListener('click', (event) => {
      if (!lockedKey || root.contains(event.target)) return;
      lockedKey = null;
      clear();
    });
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      lockedKey = null;
      clear();
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(POWER_SELECTOR).forEach(initPower);
    scope.querySelectorAll(SPECS_SELECTOR).forEach(initGeometry);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target || document));
  initAll();
})();
